import { h } from 'preact';

export const AppleIcon = () => (
	<svg width="40pt" height="47pt" viewBox="0 0 40 47" version="1.1">
		<g id="surface1">
			<path
				style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;"
				d="M 33.347656 45.121094 C 30.773438 47.59375 27.933594 47.207031 25.226562 46.042969 C 22.347656 44.851562 19.714844 44.777344 16.675781 46.042969 C 12.886719 47.65625 10.878906 47.1875 8.597656 45.121094 C -4.277344 32.007812 -2.375 12.03125 12.257812 11.28125 C 15.804688 11.46875 18.289062 13.222656 20.378906 13.367188 C 23.488281 12.742188 26.460938 10.949219 29.785156 11.1875 C 33.78125 11.503906 36.769531 13.066406 38.765625 15.871094 C 30.546875 20.761719 32.492188 31.476562 40.042969 34.484375 C 38.53125 38.410156 36.59375 42.285156 33.34375 45.152344 Z M 20.09375 11.140625 C 19.710938 5.3125 24.484375 0.515625 29.976562 0.046875 C 30.730469 6.769531 23.800781 11.796875 20.09375 11.140625 Z M 20.09375 11.140625 "
			/>
		</g>
	</svg>
);
